module.exports = __webpack_public_path__ + "static/img/pprocess1.098796c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pprocess1.png
// module id = NwHw
// module chunks = 0